import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { atsNavigation } from '@core/interfaces/navigation.interfaces';
import { ToastService } from '@core/services/toast.service';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';

@Injectable()
export class RedirectGuard implements CanActivate {
    constructor(private _router: Router,
        private _authStorageService: AuthenticationStorageService,
        private _toastService: ToastService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let hasSkip = false;
        try {
            hasSkip = this._router.getCurrentNavigation().extras.state.skip;

        } catch (e) {

        }
        if (!hasSkip) {
            const permissions = this._authStorageService.getPermissions();
            const name = route.data['name'];
            const currentRoute = atsNavigation.find(p => p.name === name);
            const childItems = currentRoute.children.filter(o => !!o.name).map(p => p);
            let navUrl = '';
            // let matchedParent = false;
            childItems.forEach(child => {
                const hasPermission = child.permissions.some(required => permissions.indexOf(required) !== -1);
                if (hasPermission) {
                    if (state.url === child.url) {
                        // matchedParent = true;
                        navUrl = child.url;
                    }
                    // if (matchedParent === false) {
                    //     navUrl = child.url;
                    // }
                }
            });
            if (!!navUrl) {
                this._router.navigate([navUrl], { state: { skip: true } });

                return true;
            }
        }
        route.queryParams = {};
        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const requiredPermission = route.data['permissions'] as Array<number>;
        const canActivate = this._authStorageService.hasAnyPermission(requiredPermission);
        if (canActivate === false) {
            this._toastService.error('You do not have permission to view this.');
        }
        return canActivate;
    }
}
